import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "@env/environment";
import {ServiceInterest} from "./interests.model";
import {GenericService} from "@ui-kit/framework/common/generic.service";

@Injectable({
  providedIn: 'root'
})
export class InterestsService extends GenericService<ServiceInterest> {
  constructor(http: HttpClient) {
    super(http, environment.apiRetailersHost + '/console/offering/district/leads/interests');
  }
}
